import { put } from "redux-saga/effects";
import { message } from "antd";

import ActivityApiCaller from "../../config/api/activityapicaller";

import { PhotoreqAction } from "../actions";

export default class PhotoreqMiddleware {
  static *getPhotoreq({ payload, cb }) {
    try {
      const action =
        payload?.filter === "Pending"
          ? "receiver/pending"
          : "receiver/accepted";

      const res = yield ActivityApiCaller.Get(
        `/activity/photo-request/${action}?sort=${payload.sort ?? ""}`
      );

      if (res?.status === 200) {
        yield put(PhotoreqAction.getPhotoreqSuccess(res.data?.data));
      } else {
        yield put(PhotoreqAction.getPhotoreqFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(PhotoreqAction.getPhotoreqFailure());
    }
  }
  static *getPhotoreqAll({ cb }) {
    try {
      const res = yield ActivityApiCaller.Get(`/activity/photo-request/all`);

      if (res?.status === 200) {
        yield put(PhotoreqAction.getPhotoreqAllSuccess(res.data?.data));
      } else {
        yield put(PhotoreqAction.getPhotoreqAllFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(PhotoreqAction.getPhotoreqAllFailure());
    }
  }
  static *sendPhotoreq({ payload, cb }) {
    try {
      const res = yield ActivityApiCaller.Post(
        "/activity/photo-request",
        payload
      );

      if (res.status === 200) {
        message.success(res.data.message);
        yield put(PhotoreqAction.sendPhotoreqSuccess(res.data.data));
        yield put(PhotoreqAction.getPhotoreqAll());
      } else {
        message.error(res.data.message);
        yield put(PhotoreqAction.sendPhotoreqFailure());
      }
      if (cb) {
        cb(res.data.data);
      }
    } catch (err) {
      message.error("Something went wrong. Please try again.");
      yield put(PhotoreqAction.sendPhotoreqFailure());
    }
  }
  static *updatePhotoreq({ payload, cb }) {
    try {
      const res = yield ActivityApiCaller.Put(
        "/activity/photo-request",
        payload
      );

      if (res.status === 200) {
        message.success(res?.data?.message);
        yield put(PhotoreqAction.updatePhotoreqSuccess(res.data.data));
      } else {
        message.error(res?.data?.message);
        yield put(PhotoreqAction.updatePhotoreqFailure());
      }
      if (cb) {
        cb(res.data.data);
      }
    } catch (err) {
      message.error("Something went wrong. Please try again.");
      yield put(PhotoreqAction.updatePhotoreqFailure());
    }
  }
}
